<template>
    <div>
        <div class="listing-header mb-4" v-if="fenologia.situacao ? fenologia.situacao == 4 : true">
            <div class="title-breadcrumb" />
            <div class="header-buttons">
                <button
                    v-if="
                        (!isUpdate && permissao.create) ||
                        (isUpdate && permissao.update)
                    "
                    @click="save(4)"
                    :disabled="isSaving||cantEdit||isLoadingEdit||existeFenologiaItem"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(1)"
                        ref="empresaSelect"
                        title="empresa"
                        :options="empresaSelect"
                        v-model="empresaSelected"
                        :required="true"
                        :invalid="empresaSelected == null"
                        :loading="empresasLoading"
                        @search="carregarEmpresas"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit || isLoadingEdit || existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('empresa')"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(2)"
                        ref="clienteSelect"
                        title="cliente"
                        :placeholder="
                            clienteSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="clienteSelect"
                        v-model="clienteSelected"
                        :required="true"
                        :invalid="clienteSelected == null"
                        :loading="clienteLoading"
                        @search="loadCliente"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByEmpresa ||
                            existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('cliente')"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(3)"
                        ref="propriedadeSelect"
                        title="propriedade"
                        :placeholder="
                            propriedadeSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="propriedadeSelect"
                        v-model="propriedadeSelected"
                        :required="true"
                        :invalid="propriedadeSelected == null"
                        :loading="propriedadeLoading"
                        @search="loadPropriedade"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByCliente ||
                            existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('propriedade')"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(4)"
                        ref="areaSelect"
                        title="area"
                        :placeholder="
                            areaSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="areaSelect"
                        v-model="areaSelected"
                        :required="true"
                        :invalid="areaSelected == null"
                        :loading="areaLoading"
                        @search="loadArea"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByPropriedade ||
                            existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('area')"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(5)"
                        ref="talhaoSelect"
                        title="talhao"
                        :placeholder="
                            talhaoSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="talhaoSelect"
                        v-model="talhaoSelected"
                        :required="true"
                        :invalid="talhaoSelected == null"
                        :loading="talhaoLoading"
                        @search="loadTalhao"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByArea ||
                            existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('talhao')"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(6)"
                        ref="planosafraSelect"
                        title="planosafra"
                        :placeholder="
                            planosafraSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="planosafraSelect"
                        v-model="planosafraSelected"
                        :required="false"
                        :loading="planosafraLoading"
                        @search="loadPlanoSafra"
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByTalhao ||
                            planosafraSelect.length < 1 ||
                            existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('planosafra')"
                    />
                </div>
                <div class="column is-6">
                    <vss-select
                        :id="generateId(7)"
                        ref="culturaSelect"
                        title="cultura"
                        :placeholder="
                            culturaSelect.length > 0
                                ? 'selecione-uma-opcao'
                                : 'sem-opcao-de-selecao'
                        "
                        searchable
                        clearable
                        :options="culturaSelect"
                        v-model="culturaSelected"
                        :required="true"
                        :invalid="
                            planosafraSelect.length < 1 &&
                            culturaSelected == null
                        "
                        :loading="culturaLoading"
                        @search="loadCultura"
                        invalidWhenDisabled
                        :disabled="
                            cantEdit ||
                            isLoadingEdit ||
                            disabledByPropriedade ||
                            existeFenologiaItem
                        "
                        @onBlurFunction="sendIsChanged('cultura')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AgroFenologiaService from "@/services/agro/fenologia/AgroFenologiaService";
import ClienteService from "@/services/vendas/cliente/ClienteService";
import PropriedadeService from "@/services/agro/PropriedadeService";
import AreaService from "@/services/agro/AreaService";
import TalhaoService from "@/services/agro/TalhaoService";
import PlanoSafraService from "@/services/agro/planosafra/PlanoSafraService";
import CulturaService from "@/services/agro/CulturaService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import FenologiaValidation from "@/services/validations/agro/FenologiaValidation";

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        cantEdit: {
            type: Boolean,
            default: false,
        },
        updateSituacao: {
            type: Boolean,
            default: false,
        },
        deleteFenologia: {
            type: Boolean,
            default: false,
        },
        existeFenologiaItem: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // Verificar se integração vai afetar esta página
            empresaService: new EmpresaService(this.$http, this.$router),
            service: new AgroFenologiaService(this.$http, this.$router),
            serviceCliente: new ClienteService(this.$http, this.$router),
            servicePropriedade: new PropriedadeService(
                this.$http,
                this.$router
            ),
            serviceArea: new AreaService(this.$http, this.$router),
            serviceTalhao: new TalhaoService(this.$http, this.$router),
            servicePlanoSafra: new PlanoSafraService(this.$http, this.$router),
            serviceCultura: new CulturaService(this.$http, this.$router),

            validation: new FenologiaValidation(this.$root.msgs),
            fenologia: {
                idAgroFaseFenologicaORegErp: null,
                situacao: null,
                latitude: null,
                longitude: null,
                lastfix: null,
                tipogps: null,

                // ligações
                idUsuario: null,
                idCliente: null,
                empresa: null,

                uuid: null,
                uuidPropriedade: null,
                uuidArea: null,
                uuidTalhao: null,
                uuidPlanoSafra: null,

                idCultura: null, // cultura

                // Models
                empresa: null,
                cliente: null,
                propriedade: null,
                area: null,
                talhao: null,
                planosafra: null,
                cultura: null,
            },

            isLoading: false,
            isSaving: false,
            
            permissao: false,
            // Controles de empresa
            empresasLoading: true,
            empresaSelect: [],
            empresaSelected: null,
            disabledByEmpresa: true,
            // Controles de cliente
            clienteLoading: true,
            clienteSelect: [],
            clienteSelected: null,
            disabledByCliente: true,
            // Controles de propriedade
            propriedadeLoading: true,
            propriedadeSelect: [],
            propriedadeSelected: null,
            disabledByPropriedade: true,
            disabledByNoPropriedade: false,
            // Controles de area
            areaLoading: true,
            areaSelect: [],
            areaSelected: null,
            disabledByArea: true,
            // Controles de talhao
            talhaoLoading: true,
            talhaoSelect: [],
            talhaoSelected: null,
            disabledByTalhao: true,
            // Controles de planosafra
            planosafraLoading: true,
            planosafraSelect: [],
            planosafraSelected: null,
            disabledByPlanoSafra: true,
            // Controles de cultura
            culturaLoading: true,
            culturaSelect: [],
            culturaSelected: null,
            disabledByCultura: true,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
            position: null,
            // Validação de carregamento de dados na edição
            countToLoad: 0,
            countLoaded: 0,
        };
    },
    watch: {
        fenologia: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit("isChanged", true);
                }
            },
        },
        updateSituacao(val) {
            if (val) {
                this.promptFinalizar();
                this.$emit("alterFinalizarFenologia");
            }
        },
        deleteFenologia(val) {
            if (val) {
                this.promptDelete();
                this.$emit("alterDeleteFenologia");
            }
        },
        isLoadingEdit(val) {
            // avisa que agora vai poder haver mudanças
            if (this.isUpdate && !val) {
                setTimeout(() => {
                    this.$emit("isChanged", false);
                }, 1000);
            }
        },
    },
    created() {
        // caso seja update inicia validação de carregamento dos dados
        if (this.isUpdate) this.isLoadingEdit = true;

        setTimeout(() => {
            this.$emit("isChanged", false);
        }, 1000);

        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-fenologia",
            "agro-fenologia"
        );

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-fenologia" },
            });
        } else {
            // pega da raiz
            this.carregarEmpresas("");

            if (this.isUpdate) {
                this.carregarDados();
                this.disabledByCliente = false;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-geral-" + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .findByUuid(this.$route.params.id)
                .then((value) => {
                    this.fenologia = Object.assign({}, value.content);
                    this.$emit("situacao", this.fenologia.situacao);
                    this.$emit("onFenologiaUpdate", this.fenologia);
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.isLoading = false;
                    // Bloqueia caso o usuário seja diferente a quem criou
                    if(this.fenologia.idUsuario!=this.$store.state.user.usuario.id) {
                        this.$emit('cantEdit', true);
                    }
                    this.countSelected();
                });
        },
        successPosition(position) {
            this.fenologia.latitude = position.coords.latitude
                ? position.coords.latitude
                : 0;
            this.fenologia.longitude = position.coords.longitude
                ? position.coords.longitude
                : 0;
            this.fenologia.lastfix = position.timestamp
                ? position.timestamp
                : null;
            this.fenologia.tipogps = position.coords.latitude ? 1 : 0;
        },
        errorPosition(e) {
            console.error("Geolocation error!", e);
        },
        save(situacao = 4) {
            this.fenologia.situacao = situacao;

            this.isLoading = true;
            // pega alocalização através do navegador caso esteja liberado
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    this.successPosition,
                    this.errorPosition
                );
            }

            setTimeout(() => {
                // preenche id e uuid dos objetos dos selects
                this.fenologia.idUsuario = this.$store.state.user.usuario.id;
                this.fenologia.empresa =
                    this.empresaSelected != null
                        ? {
                            idempresa: this.empresaSelected.id
                        }
                        : null;
                this.fenologia.idCliente =
                    this.clienteSelected != null
                        ? this.clienteSelected.id
                        : null;
                this.fenologia.uuidPropriedade =
                    this.propriedadeSelected != null
                        ? this.propriedadeSelected.uuid
                        : null;
                this.fenologia.uuidArea =
                    this.areaSelected != null ? this.areaSelected.uuid : null;
                this.fenologia.uuidTalhao =
                    this.talhaoSelected != null
                        ? this.talhaoSelected.uuid
                        : null;
                this.fenologia.uuidPlanoSafra =
                    this.planosafraSelected != null
                        ? this.planosafraSelected.uuid
                        : null;
                this.fenologia.idCultura =
                    this.culturaSelected != null
                        ? this.culturaSelected.id
                        : null;

                // passa os dados para a validação
                if (
                    this.validation.validate(this.fenologia, this.$refs) ||
                    situacao == 0
                ) {
                    // faz a cópia dos dados para não afetar os originais caso de erro
                    let fenologiaTemp = Object.assign({}, this.fenologia);

                    this.isSaving = true;
                    this.service
                        .save(fenologiaTemp)
                        .then((value) => {
                            if (value.message == null) {
                                let msgText = "msg-save-sucesso-n";
                                if (situacao == 4 && this.isUpdate) {
                                    msgText = "msg-edit-sucesso-n";
                                } else if (situacao == 1) {
                                    msgText = "msg-fenologia-finalizada";
                                } else if (situacao == 0) {
                                    msgText = "msg-delete-sucesso";
                                }

                                // novo modelo de mensagem dinâmica
                                let msg = this.$t(msgText, { n: this.$t("agro-fenologia") });

                                this.$root.showMessage(
                                    "success",
                                    msg,
                                    true,
                                    false
                                );

                                // redireciona para a tela de ...... caso venha de lá
                                if (this.$route.query.tela) {
                                    this.redirectToPage();
                                } else if (situacao == 0) {
                                    setTimeout(() => {
                                        this.$router.push({
                                            name: "agro-fenologia-list",
                                        });
                                    }, 1000);
                                } else {
                                    // caso seja atualização de situação
                                    this.$emit(
                                        "situacao",
                                        this.fenologia.situacao
                                    );
                                    // manda para a edição para adicionar os items
                                    this.redirectToEdit(value.content.uuid);
                                }
                                this.$emit("isChanged", false);
                            } else {
                                if (this.$t(value.message)) {
                                    this.$root.showMessage(
                                        "alert",
                                        value.message,
                                        true
                                    );
                                } else {
                                    this.$root.showMessage(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    );
                                }
                            }
                        })
                        .catch((e) => {
                            if (this.$t(e.body.message)) {
                                this.$root.showMessage(
                                    "alert",
                                    e.body.message,
                                    true
                                );
                            } else {
                                this.$root.showMessage(
                                    "error",
                                    "msg-erro-load",
                                    true
                                );
                            }
                        })
                        .finally(() => {
                            this.isSaving = false;
                            this.isLoading = false;
                            this.$emit("onFenologiaUpdate", this.fenologia);
                        });
                } else {
                    this.$root.showMessage(
                        "alert",
                        "msg-campos-obrigatorios",
                        true
                    );
                    this.isLoading = false;
                }
            }, 300);
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: "agro-fenologia-edit",
                    params: { id: id },
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela == "agro-fenologia") {
                tempTela = "agro-fenologia-edit";
                tempAba = "empresa";
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query["id"] },
                    query: { abaSelecionada: tempAba },
                });
            }, 1000);
        },
        countSelected() {
            // Conta o tando de dados a serem carregados do servidor
            if (this.isUpdate && this.isLoadingEdit) {
                if (
                    this.fenologia.cliente &&
                    !this.isNull(this.fenologia.cliente.nome)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.fenologia.propriedade &&
                    !this.isNull(this.fenologia.propriedade.nome)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.fenologia.area &&
                    !this.isNull(this.fenologia.area.descricao)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.fenologia.talhao &&
                    !this.isNull(this.fenologia.talhao.descricao)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.fenologia.planosafra &&
                    !this.isNull(this.fenologia.planosafra.descricao)
                ) {
                    this.countToLoad++;
                }
                if (
                    this.fenologia.cultura &&
                    !this.isNull(this.fenologia.cultura.descricao)
                ) {
                    this.countToLoad++;
                }

                this.fillSelected();
            }
        },
        fillSelected() {
            // preenche os selects com a seleção vinda com os dados da fenologia
            if (this.isUpdate && this.isLoadingEdit) {
                if (!this.isNull(this.fenologia.empresa)) {
                    this.empresaSelected = this.empresaSelect.filter(
                        (f) => f.id == this.fenologia.empresa.id
                    )[0];
                    // caso a empresa do registro não está associado ao usuário exibe mesmo assim a empresa que foi utilizada no cadastro
                    if (this.empresaSelected === undefined) {
                        this.empresaSelected = {
                            id: this.fenologia.empresa.id,
                            label: this.fenologia.empresa.nome
                        }
                    }
                }
                if (
                    this.fenologia.cliente &&
                    !this.isNull(this.fenologia.cliente.nome)
                ) {
                    this.clienteSelected = {
                        id: this.fenologia.cliente.id,
                        label: this.fenologia.cliente.nome,
                    };
                }
                if (
                    this.fenologia.propriedade &&
                    !this.isNull(this.fenologia.propriedade.nome)
                ) {
                    this.propriedadeSelected = {
                        uuid: this.fenologia.uuidPropriedade,
                        label: this.fenologia.propriedade.nome,
                    };

                    this.propriedadeLoading = false;
                }
                if (
                    this.fenologia.area &&
                    !this.isNull(this.fenologia.area.descricao)
                ) {
                    this.areaSelected = {
                        uuid: this.fenologia.uuidArea,
                        label: this.fenologia.area.descricao,
                    };

                    this.areaLoading = false;
                }
                if (
                    this.fenologia.talhao &&
                    !this.isNull(this.fenologia.talhao.descricao)
                ) {
                    this.talhaoSelected = {
                        uuid: this.fenologia.uuidTalhao,
                        label: this.fenologia.talhao.descricao,
                    };

                    this.talhaoLoading = false;
                }
                if (
                    this.fenologia.planosafra &&
                    !this.isNull(this.fenologia.planosafra.descricao)
                ) {
                    // lógica para não pegar valores nullos e mostrar dados estranhos para o usuário
                    this.planosafraSelected = {
                        uuid: this.fenologia.uuidPlanoSafra,
                        label: this.fenologia.planosafra.descricao,
                    };

                    this.planosafraLoading = false;
                }
                if (
                    this.fenologia.cultura &&
                    !this.isNull(this.fenologia.cultura.descricao)
                ) {
                    this.culturaSelected = {
                        id: this.fenologia.cultura.id,
                        label: this.fenologia.cultura.descricao,
                    };
                }
            }
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService.findList(q)
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[AGRO VISITA] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[AGRO VISITA] Mensagem: ${r.message}`);
                    } else {
                        this.empresaSelect = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .catch(e => {
                    console.error('[AGRO VISITA] Erro ao carregar empresas.', e);
                })
                .finally(_ => {
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.empresaSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.empresaSelected = this.empresaSelect[0];
                        this.sendIsChanged("empresa");
                    }
                    this.empresasLoading = false;
                });
        },
        loadCliente(termo = null, calledBySend = false) {
            /**
             * utilizado para não carregar os dados ao abrir a página pela função de search do vss.
             * assim só carregará pela primeira vez aós ser preenchido com os dados iniciais
             */
            if (!calledBySend && this.isLoadingEdit) return;

            if (this.empresaSelected == null) {
                this.clienteLoading = false;
                return;
            }

            this.clienteLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? ".*" : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.empresaSelected != null && this.empresaSelected.id
                    ? "empresa"
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.empresaSelected != null && this.empresaSelected.id
                    ? this.empresaSelected.id
                    : null,
            ];

            this.serviceCliente
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.nome,
                        };
                    });
                })
                .then((r) => {
                    this.clienteSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.clienteSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.clienteSelected = this.clienteSelect[0];
                        this.sendIsChanged("cliente");
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.clienteLoading = false;
                    this.funcCountLoaded(this.clienteSelected);
                });
        },
        loadPropriedade(termo = null, calledBySend = false) {
            if (!calledBySend && this.isLoadingEdit) return;

            if (this.clienteSelected == null) {
                this.propriedadeLoading = false;
                return;
            }
            this.propriedadeLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(termo) ? ".*" : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.clienteSelected != null && this.clienteSelected.id
                    ? "cliente"
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.clienteSelected != null && this.clienteSelected.id
                    ? this.clienteSelected.id
                    : null,
            ];

            this.servicePropriedade
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.nome,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((r) => {
                    this.propriedadeSelect = Object.assign(r);
                    if (
                        this.propriedadeSelect.length < 1 &&
                        this.clienteSelected != null
                    ) {
                        /**
                         * caso não tenha propriedade, inativa os campos :
                         * propriedade, area, talhao, plano safra e cultura
                         */
                        this.$root.showMessage(
                            "alert",
                            "cliente-sem-propriedade",
                            true
                        );
                        this.disabledByCultura = false;
                    } else {
                        //preenche automaticamente se só tiver um valor
                        if (
                            this.propriedadeSelect.length == 1 &&
                            !this.cantEdit &&
                            !this.isLoadingEdit
                        ) {
                            this.propriedadeSelected =
                                this.propriedadeSelect[0];
                            this.sendIsChanged("propriedade");
                        }

                        // carrega os dados a serem utilizados
                        if (!this.isLoadingEdit) {
                            this.loadCultura();
                        }
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.propriedadeLoading = false;
                    this.funcCountLoaded(this.propriedadeSelected);
                });
        },
        loadArea(termo = null, calledBySend = false) {
            if (!calledBySend && this.isLoadingEdit) return;

            if (this.propriedadeSelected == null) {
                this.areaLoading = false;
                return;
            }

            this.areaLoading = true;

            let params = [
                // Adicionar filtro complementar
                // filtro de busca
                this.isNull(termo) ? ".*" : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.propriedadeSelected != null &&
                this.propriedadeSelected.uuid
                    ? "propriedade"
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.propriedadeSelected != null &&
                this.propriedadeSelected.uuid
                    ? this.propriedadeSelected.uuid
                    : null,
            ];

            this.serviceArea
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.descricao,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((r) => {
                    this.areaSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.areaSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.areaSelected = this.areaSelect[0];
                        this.sendIsChanged("area");
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.areaLoading = false;
                    this.funcCountLoaded(this.areaSelected);
                });
        },
        loadTalhao(termo = null, calledBySend = false) {
            if (!calledBySend && this.isLoadingEdit) return;

            if (this.areaSelected == null) {
                this.talhaoLoading = false;
                return;
            }

            this.talhaoLoading = true;

            let params = [
                // Adicionar filtro complementar
                // filtro de busca
                this.isNull(termo) ? ".*" : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.areaSelected != null && this.areaSelected.uuid
                    ? "area"
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.areaSelected != null && this.areaSelected.uuid
                    ? this.areaSelected.uuid
                    : null,
            ];

            this.serviceTalhao
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            uuid: i.uuid,
                            label: i.descricao,
                            origempda: i.origempda,
                        };
                    });
                })
                .then((r) => {
                    this.talhaoSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.talhaoSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.talhaoSelected = this.talhaoSelect[0];
                        this.sendIsChanged("talhao");
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.talhaoLoading = false;
                    this.funcCountLoaded(this.talhaoSelected);
                });
        },
        loadPlanoSafra(termo = null, calledBySend = false) {
            if (!calledBySend && this.isLoadingEdit) return;

            if (this.talhaoSelected == null) {
                this.planosafraLoading = false;
                return;
            }

            this.planosafraLoading = true;

            let params = [
                // Adicionar filtro complementar
                // filtro de busca
                this.isNull(termo) ? ".*" : this.removeToSearch(termo),
                // parâmetro adicional com o nome do que deve ser filtrado
                this.talhaoSelected != null && this.talhaoSelected.uuid
                    ? "talhao"
                    : null,
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.talhaoSelected != null && this.talhaoSelected.uuid
                    ? this.talhaoSelected.uuid
                    : null,
            ];

            this.servicePlanoSafra
                .findAllCombo(params)
                .then((body) => {
                    return body.content.map((i) => {
                        // lógica para não pegar valores nullos e mostrar dados estranhos para o usuário
                        let label = "";
                        if (!this.isNull(i.safra.descricao)) {
                            label = i.safra.descricao;
                        }
                        if (!this.isNull(i.tipocultura.descricao)) {
                            if (label != "") label += " - ";
                            label += i.tipocultura.descricao;
                        }
                        return {
                            uuid: i.uuid,
                            label: label,
                        };
                    });
                })
                .then((r) => {
                    this.planosafraSelect = Object.assign(r);
                    // Caso não possua plano de safra o campo cultura é liberado conforme o plano de safra selecionado.
                    if (
                        this.planosafraSelect.length < 1 &&
                        !this.disabledByTalhao
                    ) {
                        this.disabledByPlanoSafra = false;
                        if (!this.isLoadingEdit) this.loadCultura();
                    } else {
                        //preenche automaticamente se só tiver um valor
                        if (
                            this.planosafraSelect.length == 1 &&
                            !this.cantEdit &&
                            !this.isLoadingEdit
                        ) {
                            this.planosafraSelected = this.planosafraSelect[0];
                            this.sendIsChanged("planosafra");
                        }
                        this.disabledByPlanoSafra = true;
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.planosafraLoading = false;
                    this.funcCountLoaded(this.planosafraSelect);
                });
        },
        loadCultura(termo = null, calledBySend = false) {
            if (!calledBySend && this.isLoadingEdit) {
                this.countLoaded++;
                return;
            }

            if (this.talhaoSelected == null && this.planosafraSelect != null) {
                this.culturaLoading = false;
                this.countLoaded++;
                return;
            }

            this.culturaLoading = true;

            this.serviceCultura
                .findAllCombo(termo)
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((r) => {
                    this.culturaSelect = Object.assign(r);
                    //preenche automaticamente se só tiver um valor
                    if (
                        this.culturaSelect.length == 1 &&
                        !this.cantEdit &&
                        !this.isLoadingEdit
                    ) {
                        this.culturaSelected = this.culturaSelect[0];
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa. Termo: [${termo}]`,
                        e
                    );
                })
                .finally((_) => {
                    // retorna como completo
                    this.culturaLoading = false;
                    this.funcCountLoaded(this.culturaSelected);
                });
        },
        loadPlanoSafraByUuid() {
            this.safraLoading = true;
            this.culturaLoading = true;

            this.servicePlanoSafra
                .findByUuid(this.planosafraSelected.uuid)
                .then((r) => {
                    if (!this.isNull(r.content.tipocultura.descricao)) {
                        this.culturaSelected = {
                            id: r.content.tipocultura.id,
                            label: r.content.tipocultura.descricao,
                        };
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally((_) => {
                    this.disabledByPlanoSafra = true;
                    this.safraLoading = false;
                    this.culturaLoading = false;
                });
        },
        sendIsChanged(label = null) {
            if (!this.isLoadingEdit) this.$emit("isChanged", true);
            // Já aproveita e faz as validações
            setTimeout(() => {
                if (this.talhaoSelected == null) this.planosafraSelect = [];

                if (label == "empresa") {
                    if (!this.isLoadingEdit) this.clienteSelected = null;

                    if (
                        this.empresaSelected != null &&
                        this.empresaSelected.id
                    ) {
                        this.disabledByEmpresa = false;
                        // carrega select dependente
                        this.loadCliente(null, true);
                    } else {
                        this.disabledByEmpresa = true;
                    }
                }

                if (label == "cliente") {
                    if (!this.isLoadingEdit) this.propriedadeSelected = null;

                    if (
                        this.clienteSelected != null &&
                        this.clienteSelected.id
                    ) {
                        this.disabledByCliente = false;
                        // carrega select dependente
                        this.loadPropriedade(null, true);
                    } else {
                        this.disabledByCliente = true;
                    }
                }

                if (label == "propriedade") {
                    if (!this.isLoadingEdit) this.areaSelected = null;

                    if (
                        this.propriedadeSelected != null &&
                        this.propriedadeSelected.uuid
                    ) {
                        this.disabledByPropriedade = false;
                        // carrega select dependente
                        this.loadArea(null, true);
                    } else {
                        this.disabledByPropriedade = true;
                    }
                }

                if (label == "area") {
                    if (!this.isLoadingEdit) this.talhaoSelected = null;

                    if (this.areaSelected != null && this.areaSelected.uuid) {
                        this.disabledByArea = false;
                        // carrega select dependente
                        this.loadTalhao(null, true);
                    } else {
                        this.disabledByArea = true;
                    }
                }

                if (label == "talhao") {
                    if (!this.isLoadingEdit) {
                        this.planosafraSelected = null;
                        this.culturaSelected = null;
                    }

                    if (
                        this.talhaoSelected != null &&
                        this.talhaoSelected.uuid
                    ) {
                        this.disabledByTalhao = false;
                        // carrega select dependente
                        this.loadPlanoSafra(null, true);
                    } else {
                        this.disabledByTalhao = true;
                        this.disabledByPlanoSafra = true;
                    }
                }

                if (label == "planosafra") {
                    if (!this.isLoadingEdit) {
                        this.culturaSelected = null;
                    }

                    if (this.planosafraSelected != null) {
                        this.loadPlanoSafraByUuid();
                    } else if (this.planosafraSelect.length < 1) {
                        this.disabledByPlanoSafra = false;
                    }
                }
                if (label == "cultura") {
                    if (
                        this.isUpdate &&
                        this.isLoadingEdit &&
                        this.planosafraSelected == null
                    )
                        this.loadCultura(null, true);
                }
            }, 200);
        },
        funcCountLoaded(objSelected) {
            // adiciona ao contador de dados carregados da edição
            if (this.isLoadingEdit && objSelected != null) {
                this.countLoaded++;
                /**
                 * caso seja edição e o tanto de dados a serem carregados condizer,
                 * avisa que acabou o loading da edição
                 */
                if (this.countToLoad == this.countLoaded) {
                    setTimeout(() => {
                        this.isLoadingEdit = false;
                    }, 1000);
                }
            }
        },
        promptDelete() {
            let message = this.$t("msg-confirmacao-exclusao-n", { n: '' });
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.save(0),
            });
        },
        promptFinalizar() {
            let message = this.$t("msg-confirm-finalizar-atividade-n", { n: '' });
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.save(1),
            });
        },
    },
};
</script>